<div class="tt-medication-card_header">
  <div class="tt-medication-card_header-title">
    {{ medication().title }}
  </div>
  <div class="tt-medication-card_header-actions">
    <button ttButton [size]="'icon'" [variant]="'transparent'" (click)="editClicked.emit()">
      <mat-icon [icon]="'pencil'" [iconSize]="14" />
    </button>
    <button ttButton [size]="'icon'" [variant]="'transparent'" (click)="deleteClicked.emit()">
      <mat-icon [icon]="'x'" [iconSize]="14" />
    </button>
  </div>
</div>

@if (medication().description) {
  <common-rich-text-view [content]="medication().description" />
}
